module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.2d260768.jpeg";